import React, { useEffect, useState } from 'react'
import { ManagePartnerGrid } from './components/ManagePartnerGrid'
import AddMemberModal from './components/modals/AddMemberModal'
import EditMemberModal from './components/modals/EditMemberModal'
import { getMember, getMembers, getPartnerTypes } from '../../services/membersPartnerService'
import Pagination from '../components/Pagination'
import { Stats } from './models'
import SearchField from './components/fields/SearchField'

export const ManagePartnerPage: React.FC = () => {
  const limit = 10;
  const [membersData, setMembersData] = useState([])
  const [loading, setLoading] = useState<boolean>(false)
  const [memberInfo, setMemberInfo] = useState({})
  const [showInviteModal, setShowInviteModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [paginationData, setPaginationData] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [reloadMembers, setReloadMembers] = useState(0)
  const [error, setError] = useState<Error | null>(null)
  const [activeTab, setActiveTab] = useState('agency')
  const [stats, setStats] = useState<Stats>({activePartners:0, inactivePartners:0, totalPartners:0 })
  const [search, setSearch] = useState('')
  const totalPages = paginationData ? Math.ceil(paginationData.count / limit) : 1;
  const partnerTypes = [
    {id: 'agency', name: 'Travel Partner'},
    {id: 'expert', name: 'Expert'},
  ]

  const getData = (params: any = {}) => {
    let isMounted = true
    const fetch = async () => {
      try {
        const data = await getMembers({...params})
        if (isMounted) {
          setPaginationData(data);
          setMembersData(data.results);
          setStats(data.stats)
        }
      } catch (err) {
        if (isMounted) {
          setError(err as Error)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }
    fetch()
    return () => {
      isMounted = false
    }
  }

  const handleAdd = () => {
    setShowInviteModal(false)
    handlePageChange(currentPage)
  }

  const handleEdit = async () => {
    setShowEditModal(false)
    handlePageChange(currentPage)
  }

  const onRowClick = async (id:number) => {
    const member2 = await getMember(id);
    setMemberInfo(member2)
    setShowEditModal(true)
  };

  const handleRefresh = () => {
    handlePageChange(currentPage)
  }

  const handlePageChange = async (page: number) => {
    const offset = (page - 1) * limit;
    await getData({ limit, offset, type:activeTab });
    setCurrentPage(page);
  };

  const handleChangeSearch = async (search:string) => {
    let params = { limit, offset:0, search:search, type:activeTab };
    await setSearch(search)
    if(search == ''){
      delete params.search
    }
    await getData(params);
    setCurrentPage(1);
  }
  
  const handleChangeTab = async (tab:string) => {
    try {
      setLoading(true);
      await setActiveTab(tab);
      let params = { limit, offset:0, search:search, type:tab };
      await getData(params);
      setCurrentPage(1);
    }
    finally {
      setLoading(false);
    }
  }

  return (
    <div className='manage-member-page'>

      <div className='manage-member-page__content'>
        <div className="d-flex flex-row w-100 justify-content-between">
          <div className="tap-host-title">Partners</div>
          <div className="tap-add-experience-2-btn-main" onClick={() => setShowInviteModal(true)}>
            <div className="tap-host-button-text tap-flex-center">
              + Add new partner &nbsp;{/* <KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' /> */}
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className='tab-navigation'>
          {(partnerTypes || []).map((tab:any, index:number) => (<div key={tab.id} className='d-flex flex-row'>
            <div className={`tab-navigation__item ${activeTab === tab.id ? 'tab-navigation__item--selected' : ''}`}
              onClick={()=>handleChangeTab(tab.id)}
            >
              <div className='tab-navigation__label'>{tab.name}</div>
            </div>
            <li className={`separator-vertical ${index < partnerTypes.length - 1 ? 'd-flex' : 'd-none'}`}>
              <hr />
            </li>
          </div>))}
        </div>
        {/* Search */}
        <SearchField onChange={handleChangeSearch} />
        {/* stats */}
        <div className="member-stats">
          <div className="stat-card">
            <div className="stat-card__content">
              <div className="stat-card__label">Total partners</div>
              <div className="stat-card__value">{stats?.totalPartners ?? 0}</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card__content">
              <div className="stat-card__label">Active</div>
              <div className="stat-card__value">{stats?.activePartners ?? 0}</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-card__content">
              <div className="stat-card__label">Suspended</div>
              <div className="stat-card__value">{stats?.inactivePartners ?? 0}</div>
            </div>
          </div>
        </div>

        <div key={reloadMembers} className='manage-member-page__table'>
          <ManagePartnerGrid
            members={membersData}
            loading={loading}
            onEdit={onRowClick} 
            refresh={handleRefresh}
            currentPage={currentPage} 
            totalPages={totalPages} 
            onPageChange={handlePageChange} 
          />
        </div>
      </div>

      <AddMemberModal
        isOpen={showInviteModal}
        onClose={() => handleAdd()}
      />

      <EditMemberModal
        isOpen={showEditModal}
        memberInfo={memberInfo}
        onClose={() => handleEdit()}
      />
    </div>
  )
}
